import React from 'react';

import { Grid, Skeleton } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import SquareIcon from '@mui/icons-material/Square';

const useStyles = makeStyles((theme) => ({
  legendText: {
    color: theme.palette.text.secondary
  },
  legendIconSkeleton: {
    width: theme.spacing(1.5),
    height: theme.spacing(1.5),
    marginRight: theme.spacing(0.4),
    color: theme.palette.grey[300]
  },
  skeletonBox: {
    display: 'flex',
    paddingLeft: theme.spacing(3),
    alignItems: 'center'
  }
}));

const HeaderSkeleton = () => {
  const classes = useStyles();

  return (
    <Grid container item xs={12} justifyContent={'flex-end'}>
      {Array.from(new Array(3)).map((_, i) => (
        <Grid key={i} item className={classes.skeletonBox}>
          <SquareIcon
            fontSize="small"
            className={classes.legendIconSkeleton}
            data-testid={'square-Icon-skeleton'}
          />

          <Skeleton
            variant="text"
            className={classes.legendText}
            height={30}
            width={80}
            data-testid={'skeleton-text'}
          />
        </Grid>
      ))}
    </Grid>
  );
};
export default React.memo(HeaderSkeleton);
